<template>
		
		<div v-if="pointsOfInterest.length > 0" id="wrapper">
			<h1 v-if="currentTitle">{{ currentTitle }}</h1>
			<VisualMedium @videostart="bCanChangeImage = false" @videoend="bCanChangeImage = true" :css="mediaStyle" :source="currentImageURL"></VisualMedium>
			<div id="previous" @click="bCanChangeImage = true;showPreviousPoiImage()"><button class="hidden" ref="previous">&lt;</button></div>
			<div id="next" @click="bCanChangeImage = true;showNextPoiImage()"><button class="hidden" ref="next">&gt;</button></div>
			<AudioMedium :lang="currentLanguage" @endplay="onAudioEnd()" :source="audioSrc"></AudioMedium>
		</div>

</template>

<script>
/* eslint-disable */
import VisualMedium from './visual-medium.vue'
import AudioMedium from './audio-medium.vue'
import BistrobusLogo from '@/assets/images/logo_bistrobus.png'

const SLIDESHOW_SPEED = 10000;
let currentKey = 0;
const COMMENTS_API_URL = 'https://www.bordeaux-phototour.com/api/comments';//'http://localhost';

export default {

	name: 'PoiSlideshow',

	components: {
		VisualMedium,
		AudioMedium
	},

	props: {
		language: String,
		isReal: Number,
		realPosition: Object,
		pointsOfInterests: Array
	},

	data () {
		return {
			pointsOfInterest: [],
			waitingImgs: [
			],
			playedComments: [],
			currentImageURL: '',
			currentTitle: '',
			watchId: undefined,
			timerId: undefined,
			currentLocation: {},
			debug: undefined,
			currentPOIIndex: undefined,
			currentPhotoIndex: 0,
			currentLanguage: this.language,
			checkPosition: [this.simulateTour, this.checkRealPosition],
			tour: [],
			simCoords: [],
			mediaStyle: {
				media: {
					'max-width': '100vw',
					'max-height': '45vh',
					'margin': 'auto'
				},
				container: {
					'grid-column-start': '1',
					'grid-column-end': '4',
					'grid-row': '2',
					'align-self': 'center',
					'justify-self': 'center'
				}
			},
			audioSrc: '',
			bCanChangeImage: true,
			bCanChangePOI: true
		};
	},

	watch: {
		language: function(newVal, oldVal) {
			this.currentLanguage = newVal;
			if (this.currentPOIIndex === undefined) {
				this.updatePOIIndex(null);
			}
		},

		currentLocation(val) {
			/*this.checkForPOI({
				lat: val.lat,
				lon: val.lon
			});*/
		},

		realPosition(val) {
			this.checkForPOI(val);
			this.updateLocation(val);
		},

		pointsOfInterests(val) {

			for(let i = 0; i < val.length; i++) {
				let current = val[i];

				if (current.images != undefined) {

					let poi = {
						id: current.id,
						id_comment: current.ref_comment,
						radius: current.radius,
						key: currentKey++,
						title: current.name,
						description: {
							en: current.desc_en,
							fr: current.desc_fr
						},
						images: current.images.map((e) => {
							return {
								file: 'https://www.bordeaux-phototour.com/images/'+ e.image_dir +'/'+ e.file
							};
						}),
						coords: {lon: current.lng, lat: current.lat}
					};

					this.pointsOfInterest.push(poi);
				}
				else {
					let poi = {
						geometry: current.geometry
					};
					this.simCoords.push(poi);
				}
			}//end for

			if (!this.isReal) {

				let self = this;

				fetch('/precise.json', {method: 'get', cache: 'force-cache'})
				.then((response) => response.json())
				.then((response) => {
					vm.tour = response.features[0].geometry.coordinates;
					self.checkPosition[self.isReal]();

					//begin slideshow
					setInterval(self.showNextPoiImage, SLIDESHOW_SPEED);
				})
				.catch((err) => {
					console.error(err);
				});

			}
			else {
				this.checkPosition[this.isReal]();

				//begin slideshow
				setInterval(this.showNextPoiImage, SLIDESHOW_SPEED);
			}

		}
	},

	mounted() {

		this.updatePOIIndex(null);

	},

	methods: {
		playNewAudio(audioId) {
			this.bCanChangePOI = false;
			console.log('https://www.bordeaux-phototour.com/audios/'+ this.currentLanguage +'/'+ audioId +'.mp3');
			this.audioSrc = 'https://www.bordeaux-phototour.com/audios/'+ this.currentLanguage +'/'+ audioId +'.mp3';
			this.playedComments.push(audioId);
		},
		onAudioEnd() {
			this.bCanChangePOI = true;
			this.updatePOIIndex(null);
		},
		showPreviousPoiImage(){
			if(this.bCanChangeImage && this.currentPOIIndex !== undefined){
				if(this.currentPhotoIndex > 0) {
					this.currentPhotoIndex--;
				}
				else {
					this.currentPhotoIndex = this.pointsOfInterest[this.currentPOIIndex].images.length - 1;
				}

				if (this.pointsOfInterest[this.currentPOIIndex] !== undefined) {
					this.currentImageURL = this.pointsOfInterest[this.currentPOIIndex].images[this.currentPhotoIndex].file;
				}

			}
		},
		showNextPoiImage(){
			if (this.bCanChangeImage && this.currentPOIIndex !== undefined) {
				if (this.currentPhotoIndex < this.pointsOfInterest[this.currentPOIIndex].images.length - 1) {
					this.currentPhotoIndex++;
				}
				else {
					this.currentPhotoIndex = 0;
				}

				if (this.pointsOfInterest[this.currentPOIIndex] !== undefined) {
					this.currentImageURL = this.pointsOfInterest[this.currentPOIIndex].images[this.currentPhotoIndex].file;
				}

			}
		},
		updatePOIIndex(poiId){
			
			if (poiId !== null) {

				let index = undefined;
				let i = 0;

				while(i < this.pointsOfInterest.length) {
					let current = this.pointsOfInterest[i];

					if (current.id == poiId) {
						index = i;
						break;
					}

					i++;
				}

				this.currentPOIIndex = index;
				this.currentTitle = this.pointsOfInterest[this.currentPOIIndex].title;
				this.showNextPoiImage();

				if (index !== undefined) {
					if (this.pointsOfInterest[this.currentPOIIndex].images.length > 1) {
						this.$refs.previous.classList.remove('hidden');
						this.$refs.next.classList.remove('hidden');
						this.$refs.previous.classList.add('button');
						this.$refs.next.classList.add('button');
					}
				}
			}
			else {

				let self = this;

				this.updateWaintingImgs()
				.then(() => {
					self.currentImageURL = self.waitingImgs[Math.floor(Math.random() * (self.waitingImgs.length - 1))];
				})
				.catch(e => console.error(e));

				this.currentPOIIndex = undefined;
				this.currentTitle = '';

				this.$refs.previous.classList.add('hidden');
				this.$refs.next.classList.add('hidden');
				this.$refs.previous.classList.remove('button');
				this.$refs.next.classList.remove('button');

			}

		},
		updateWaintingImgs() {

			let self = this;

			return fetch(COMMENTS_API_URL +'/images/waiting/'+ this.currentLanguage)
			.then(r => r.json())
			.then((r) => {
				console.log(r);
				self.waitingImgs = r.data.map((e) => {
					return 'https://www.bordeaux-phototour.com/images/'+ e.image_dir +'/'+ e.file;
				});
			});

		},
		setPOIByIndex(index){
			for (var i = this.pointsOfInterest.length.length - 1; i >= 0; i--) {
				let current = this.pointsOfInterest.length[i];
				if(current.id == index){
					this.currentPOIIndex = i;
				}
			}
		},
		checkForPOI(location) {

			if (this.pointsOfInterest.length > 0 && this.bCanChangePOI === true) {

				for(let i = 0; i < this.pointsOfInterest.length; i++) {

					let e = this.pointsOfInterest[i];

					//check played already
					if (e.id_comment !== null) {

						if (this.playedComments.find(id => id == e.id_comment) === undefined) {

							//check distance
							if (this.math_haversine(this.realPosition.lon, this.realPosition.lat, e.coords.lon, e.coords.lat) <= e.radius) {
								//play if can play
								this.playNewAudio(e.id_comment);
								this.updatePOIIndex(e.id);
							}

						}

					}

				}

			}

		},
		checkRealPosition(){
			
		},
		updateLocation(location) {
			this.currentLocation = location;
		},
		checkSimulatedPosition(currentPosition){
			this.checkForPOI(currentPosition);
		},
		simulateTour(){

			let currentPosition = -1;
			let self = this;
			this.timerId = setInterval(function () {
				currentPosition++;
				if (currentPosition < vm.tour.length) {
					let position = {
						lat: vm.tour[currentPosition][1],
						lon: vm.tour[currentPosition][0]
					};
					self.updateLocation(position);
					self.currentLocation = position;
					self.$emit('updatesim', position);
					self.checkSimulatedPosition(position);
				}
				else {
					currentPosition = 0;
				}
			}, 5000);
		},
		math_haversine(lonFrom, latFrom, lonTo, latTo) {
		    let earth_radius = 6371000;
		    
		    let dLat = this.math_deg2rad(latTo - latFrom);
		    let dLon = this.math_deg2rad(lonTo - lonFrom);
		    
		    let a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(this.math_deg2rad(latFrom)) * Math.cos(this.math_deg2rad(latTo)) * Math.sin(dLon/2) * Math.sin(dLon/2);
		    let c = 2 * Math.asin(Math.sqrt(a));
		    let d = earth_radius * c;
		    
		    return Math.round(d);
		},
		math_deg2rad(v) {
			return v * (Math.PI / 180);
		}
	}

}
</script>

<style lang="css">

.hidden
{
	background-color: rgba(0, 0, 0, 0);
	color: rgba(0, 0, 0, 0);
	border-color: rgba(0, 0, 0, 0);
}

.button
{
	width: 50px;
	height: 50px;
	border: 2px solid white;
	color: white;
	border-radius: 50px;
	text-decoration: none;
	background-color: rgba(0, 0, 0, 0.2);
	font-size: 1em;
	font-weight: bold;
	outline: none;
}
.button:active
{
	animation-name: buttonClick;
	animation-duration: 0.5s; 
}

@keyframes buttonClick
{
	0% {background-color: rgba(0, 0, 0, 0.2); color: white;}
	50% {background-color: white; color: black;}
	100% {background-color: rgba(0, 0, 0, 0.2); color: white;}
}

</style>

<style lang="css" scoped>

#wrapper
{
	grid-row: 1;
	display: grid;
	grid-template-rows: auto auto auto;
}

#slideshow
{
	display: grid;
	grid-template-rows: auto auto auto;
	grid-template-columns: auto auto auto;
}

#previous
{
	grid-row: 2;
	grid-column: 1;
	justify-self: center;
	align-self: center;
}
#next
{
	grid-row: 2;
	grid-column: 3;
	justify-self: center;
	align-self: center;
}

h1
{
	grid-column: 2;
	grid-row: 1;
	text-align: center;
	align-self: center;
	background-color: rgba(0, 0, 0, 0);
	border-radius: 5px;
	padding: 5px;
}

</style>
